// 330, // applicationFee
// 660, // establishmentFee
// 550, // legalFee
// 70, // verificationValuationFee
// 15 // monthlyFee

const applicationFeeForPersonal = 330;
const applicationFeeForUsed = 440;
const establishmentFee = 660;
const legalFee = 550;
const verificationValuationFee = 70;
const monthlyFee = 15;
const assessmentPercentage = process.env.REACT_APP_ASSESSMENT_RATE_PERCENTAGE;

export {
  applicationFeeForPersonal,
  applicationFeeForUsed,
  establishmentFee,
  legalFee,
  verificationValuationFee,
  monthlyFee,
  assessmentPercentage,
};
